import React, { useState, useEffect } from "react"
import BasicContent from "./BasicContent/basicContent"
import Booking from "./Bookings/booking"
import NoSetup from "./noSetup"
import {
  addMenuFeature,
  deleteMenuItem,
  editMenuItem,
  getFeatureDeepLinkUrl,
  getFeatureDeeplinkCodes,
  getMenuIcons,
  hideDeleteFeatureModal,
  hideFeatureNotificationModal,
  hideSelectIconModal,
  openSelectIconModal,
  setIsOutdated,
  setSelectedFeature,
  updateEventMenuFeaturesOrder,
  updateLandingFeatureOrder,
} from "store/actions"
import { connect } from "react-redux"
import {
  CardBody,
  Modal,
  Spinner,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
} from "reactstrap"
import Select from "react-select"
import "components/style.scss"
import ModalComponent from "components/Modals"
import { SaveButton } from "components/Buttons"
import DocumentList from "./Document/documentList"
import EventInfo from "./EventInfo/eventInfo"
import LeaderboardMenuFeature from "./Leaderboard/index"
import MediaGallery from "./MediaGallery/index"
import CommentBoard from "./CommentBoard/commentBoard"
import PropTypes from "prop-types"
import CountdownClockFeature from "./CountdownClock/countdownClockFeature"
import DocumentMenuFeature from "./Document/documentMenuFeature"
import FormBuilderMenuFeature from "./FormBuilder/formBuilderMenuFeature"
import ListMenuFeature from "./List/listMenuFeature"
import PlacesMenuFeature from "./Places/placesMenuFeature"
import PollMenuFeature from "./Poll/pollMenuFeature"
import PrivateMessageMenuFeature from "./PrivateMessage/privateMessageMenuFeature"
import ReferFriendMenuFeature from "./ReferFriend/referFriendMenuFeature"
import QuestionnaireMenuFeature from "./Questionnaire/questionnaireMenuFeature"
import SurveyMenuFeature from "./Survey/surveyMenuFeature"
import TriviaMenuFeature from "./TriviaChallenge/triviaMenuFeature"
import CalendarEventsMenuFeature from "./CalendarEvents/calendarEventsMenuFeature"
import VideoCallMenuFeature from "./VideoCall/videoCallMenuFeature"
import WebLinkMenuFeature from "./WebLink/webLinkMenuFeature"
import {
  DndContext,
  MouseSensor,
  TouchSensor,
  closestCenter,
  useSensor,
  useSensors,
} from "@dnd-kit/core"
import {
  SortableContext,
  arrayMove,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable"
import MenuFeatureListItem from "./menuFeatureListItem"

const getWindowDimensions = () => {
  const { innerWidth: width, innerHeight: height } = window
  return {
    width,
    height,
  }
}

const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  )

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return windowDimensions
}

const MenuFeature = ({
  vendorId,
  selectedEvent,
  showSavingModal,
  addMenuFeature,
  getMenuIcons,
  isSelectIconModalOpen,
  menuIcons,
  openSelectIconModal,
  hideSelectIconModal,
  editMenuItem,
  hideDeleteFeatureModal,
  isDeleteFeatureModalOpen,
  deleteMenuItem,
  featureDropdownList,
  menuList,
  updateMenuList,
  isOutdated,
  setIsOutdated,
  selectedFeature,
  setSelectedFeature,
  design,
  getFeatureDeepLinkUrl,
  isEventFeature,
  getFeatureDeeplinkCodes,
  vendorConfig,
  updateEventMenuFeaturesOrder,
  updateLandingFeatureOrder,
  landingSetup,
  updateIsLoading,
  deleteIsLoading,
  featureNotificationModalIsOpen,
  hideFeatureNotificationModal,
}) => {
  const [featureIsLoaded, setFeatureIsLoaded] = useState(false)
  const { height, width } = useWindowDimensions()
  const sensors = useSensors(useSensor(MouseSensor), useSensor(TouchSensor))
  const [editParams, setEditParams] = useState(null)

  useEffect(() => {
    getMenuIcons()
    return () => {
      setSelectedFeature(null)
    }
  }, [])

  useEffect(() => {
    if (selectedFeature) {
      setFeatureIsLoaded(true)
    }
  }, [selectedFeature])

  useEffect(() => {
    if (isEventFeature && vendorConfig && selectedFeature) {
      if (
        vendorConfig?.nfc_hyperlinks ||
        vendorConfig?.communication_hyperlinks
      ) {
        getFeatureDeepLinkUrl({
          eventId: selectedEvent?.id,
          featureId: selectedFeature?.id,
        })
      }
      if (vendorConfig?.nfc_hyperlinks) {
        getFeatureDeeplinkCodes({
          menu_item_id: selectedFeature?.id,
          event_id: selectedEvent?.id,
          type: 3,
          page: 1,
          per_page: 10,
          o: "created_at",
          od: "desc",
        })
      }
    }
  }, [selectedFeature, vendorConfig])

  useEffect(() => {
    if (isOutdated) {
      updateMenuList()
      setIsOutdated(false)
    }
  }, [isOutdated])

  const handleDragEnd = event => {
    const { active, over } = event
    if (active && over && active.id !== over.id) {
      const oldIndex = menuList.findIndex(i => i.id === active.id)
      const newIndex = menuList.findIndex(i => i.id === over.id)
      const modifiedData = arrayMove(menuList, oldIndex, newIndex)

      if (isEventFeature && !!selectedEvent) {
        updateEventMenuFeaturesOrder(
          {
            ...selectedEvent?.design,
            menu: modifiedData.map((item, position) => ({
              ...item,
              order: position + 1,
            })),
          },
          selectedEvent?.id
        )
      } else {
        updateLandingFeatureOrder({
          ...landingSetup,
          menu: modifiedData.map((item, position) => ({
            ...item,
            order: position + 1,
          })),
        })
      }
    }
  }

  const featureDeleteHandler = () => {
    deleteMenuItem({
      menu_item_id: selectedFeature.id,
      type: isEventFeature ? "event" : "landing",
    })
    setSelectedFeature(null)
  }

  const setIconHandler = icon => {
    editMenuItem({
      data: { menu_icon_id: icon.id, menu_item_id: selectedFeature?.id },
      type: isEventFeature ? "event" : "landing",
    })
    hideSelectIconModal()
  }

  const renderFeature = () => {
    switch (selectedFeature?.feature) {
      case "basic_content":
        return (
          <BasicContent
            feature={selectedFeature}
            isEventFeature={isEventFeature}
          />
        )
      case "guest_list":
      case "register_guest":
      case "camera":
        return (
          <NoSetup feature={selectedFeature} isEventFeature={isEventFeature} />
        )
      case "comment_board":
        return (
          <CommentBoard
            feature={selectedFeature}
            fromEvent={true}
            isEventFeature={isEventFeature}
          />
        )
      case "booking_service":
      case "view_bookings":
        return (
          <Booking
            feature={selectedFeature}
            design={design}
            isEventFeature={isEventFeature}
          />
        )
      case "countdown_clock":
        return (
          <CountdownClockFeature
            feature={selectedFeature}
            design={design}
            isEventFeature={isEventFeature}
          />
        )
      case "documents":
        return selectedFeature.type === 1 ? (
          <DocumentMenuFeature
            feature={selectedFeature}
            isEventFeature={isEventFeature}
          />
        ) : (
          <DocumentList
            feature={selectedFeature}
            isEventFeature={isEventFeature}
          />
        )
      case "event_info":
        return (
          <EventInfo
            feature={selectedFeature}
            design={design}
            isEventFeature={isEventFeature}
          />
        )
      case "form_builders":
        return (
          <FormBuilderMenuFeature
            feature={selectedFeature}
            design={design}
            isEventFeature={isEventFeature}
          />
        )
      case "leaderboard":
        return (
          <LeaderboardMenuFeature
            feature={selectedFeature}
            isEventFeature={isEventFeature}
          />
        )
      case "lists":
        return (
          <ListMenuFeature
            feature={selectedFeature}
            design={design}
            isEventFeature={isEventFeature}
          />
        )
      case "media":
        return (
          <MediaGallery
            feature={selectedFeature}
            isEventFeature={isEventFeature}
          />
        )
      case "places":
        return (
          <PlacesMenuFeature
            feature={selectedFeature}
            isEventFeature={isEventFeature}
          />
        )
      case "polls":
        return (
          <PollMenuFeature
            feature={selectedFeature}
            design={design}
            isEventFeature={isEventFeature}
          />
        )
      case "private_message":
        return (
          <PrivateMessageMenuFeature
            feature={selectedFeature}
            isEventFeature={isEventFeature}
          />
        )
      case "refer_friend":
        return (
          <ReferFriendMenuFeature
            feature={selectedFeature}
            isEventFeature={isEventFeature}
          />
        )
      case "questionnaires":
        return (
          <QuestionnaireMenuFeature
            feature={selectedFeature}
            design={design}
            isEventFeature={isEventFeature}
          />
        )
      case "surveys":
        return (
          <SurveyMenuFeature
            feature={selectedFeature}
            design={design}
            isEventFeature={isEventFeature}
          />
        )
      case "trivia_challenge":
        return (
          <TriviaMenuFeature
            feature={selectedFeature}
            design={design}
            isEventFeature={isEventFeature}
          />
        )
      case "calendar":
        return (
          <CalendarEventsMenuFeature
            feature={selectedFeature}
            design={design}
            isEventFeature={isEventFeature}
          />
        )
      case "custom_web_links":
        return (
          <WebLinkMenuFeature
            feature={selectedFeature}
            design={design}
            isEventFeature={isEventFeature}
          />
        )
      case "video_call":
        return (
          <VideoCallMenuFeature
            feature={selectedFeature}
            isEventFeature={isEventFeature}
          />
        )
      default:
        return <></>
    }
  }

  return (
    <React.Fragment>
      <Row style={width >= 1200 ? { maxHeight: height } : {}}>
        <Col xl={"auto"}>
          <Row className="my-3">
            <Select
              onChange={selected => {
                setFeatureIsLoaded(false)
                addMenuFeature({
                  data: {
                    event_id: selectedEvent ? selectedEvent.id : null,
                    machine_name: selected.value,
                    type: selected.type,
                    vendor_id: vendorId,
                  },
                  type: isEventFeature ? "event" : "landing",
                })
              }}
              value={null}
              classNamePrefix="select2-selection"
              options={featureDropdownList}
              placeholder="Choose A Menu Feature"
              menuPortalTarget={document.body}
            />
          </Row>
          <Row
            style={
              !!height && width >= 1200
                ? { maxHeight: height - 70, overflow: "auto" }
                : {}
            }
          >
            <Col>
              <ListGroup>
                <ListGroupItem className="border-0 pb-0">
                  <Row>
                    <Col xs={2} md={1} className="p-0">
                      <label>Order</label>
                    </Col>
                    <Col xs={2}>
                      <label>Icon</label>
                    </Col>
                    <Col>
                      <label>Feature Name</label>
                    </Col>
                    <Col xs={3} md={2} xl={3}>
                      <label>Actions</label>
                    </Col>
                  </Row>
                </ListGroupItem>
                <DndContext
                  sensors={sensors}
                  collisionDetection={closestCenter}
                  onDragEnd={handleDragEnd}
                >
                  <SortableContext
                    items={menuList}
                    strategy={verticalListSortingStrategy}
                  >
                    {menuList?.map(item => {
                      return (
                        <MenuFeatureListItem
                          key={item?.id}
                          item={item}
                          setFeatureIsLoaded={setFeatureIsLoaded}
                          setSelectedFeature={setSelectedFeature}
                          selectedFeature={selectedFeature}
                          openSelectIconModal={openSelectIconModal}
                          selectedEvent={selectedEvent}
                          isEventFeature={isEventFeature}
                          setEditParams={setEditParams}
                        />
                      )
                    })}
                  </SortableContext>
                </DndContext>
              </ListGroup>
            </Col>
          </Row>
        </Col>
        <Col
          style={
            !!height && width >= 1200
              ? { maxHeight: height, overflow: "auto" }
              : {}
          }
        >
          {featureIsLoaded && renderFeature()}
        </Col>
      </Row>
      <ModalComponent
        title="Set Icon"
        open={isSelectIconModalOpen}
        onClose={hideSelectIconModal}
      >
        {menuIcons.map(icon => (
          <img
            key={icon.id}
            src={icon.url}
            style={
              selectedFeature?.icon?.id === icon.id
                ? {
                    width: "30px",
                    height: "auto",
                    cursor: "pointer",
                    margin: "4px",
                    border: "1px solid red",
                  }
                : {
                    width: "30px",
                    height: "auto",
                    cursor: "pointer",
                    margin: "4px",
                  }
            }
            onClick={() => setIconHandler(icon)}
          />
        ))}
      </ModalComponent>
      <ModalComponent
        title="Delete Feature"
        open={isDeleteFeatureModalOpen}
        onClose={hideDeleteFeatureModal}
      >
        <Row>
          <h5>Are you sure you want to delete the selected feature?</h5>
        </Row>
        <Row className="mt-3">
          <Col>
            <SaveButton
              type="button"
              fullWidth={true}
              color="danger"
              content="Cancel"
              onClick={hideDeleteFeatureModal}
            />
          </Col>
          <Col>
            <SaveButton
              content="Delete"
              fullWidth={true}
              onClick={featureDeleteHandler}
              loading={deleteIsLoading}
            />
          </Col>
        </Row>
      </ModalComponent>
      <ModalComponent
        open={featureNotificationModalIsOpen}
        onClose={hideFeatureNotificationModal}
      >
        <Row>
          <h5>
            Would you like to send a push notification to alert users that this
            feature has been created?
          </h5>
        </Row>
        <Row className="mt-3 d-flex justify-content-end">
          <Col xs="auto">
            <SaveButton
              type="button"
              content="No"
              onClick={() => {
                if (editParams) {
                  editMenuItem({
                    data: {
                      ...editParams,
                      send_notification: false,
                    },
                    type: isEventFeature ? "event" : "landing",
                  })
                }
              }}
              loading={updateIsLoading}
            />
          </Col>
          <Col xs="auto">
            <SaveButton
              type="button"
              content="Yes"
              onClick={() => {
                if (editParams) {
                  editMenuItem({
                    data: {
                      ...editParams,
                      send_notification: true,
                    },
                    type: isEventFeature ? "event" : "landing",
                  })
                }
              }}
              loading={updateIsLoading}
            />
          </Col>
        </Row>
      </ModalComponent>
      <Modal isOpen={showSavingModal} centered={true} size="sm">
        <h4 style={{ textAlign: "center" }}>Saving...</h4>
        <CardBody className={"p-2 my-1 text-center"}>
          <Spinner className="ms-2" color="primary" />
        </CardBody>
      </Modal>
      <Modal isOpen={updateIsLoading} centered={true} size="sm">
        <h4 style={{ textAlign: "center" }}>Saving...</h4>
        <CardBody className={"p-2 my-1 text-center"}>
          <Spinner className="ms-2" color="primary" />
        </CardBody>
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  selectedEvent: state.experiences.selectedEvent,
  showSavingModal: state.menuFeatures.showSavingModal,
  isSelectIconModalOpen: state.menuFeatures.isSelectIconModalOpen,
  menuIcons: state.menuFeatures.menuIcons,
  isDeleteFeatureModalOpen: state.menuFeatures.isDeleteFeatureModalOpen,
  isOutdated: state.menuFeatures.isOutdated,
  selectedFeature: state.menuFeatures.selectedFeature,
  updateIsLoading: state.menuFeatures.updateIsLoading,
  deleteIsLoading: state.menuFeatures.deleteIsLoading,
  vendorConfig: state.clients.vendorConfig,
  featureNotificationModalIsOpen:
    state.menuFeatures.featureNotificationModalIsOpen,
})

const mapDispatchToProps = dispatch => ({
  addMenuFeature: values => dispatch(addMenuFeature(values)),
  getMenuIcons: () => dispatch(getMenuIcons()),
  openSelectIconModal: () => dispatch(openSelectIconModal()),
  hideSelectIconModal: () => dispatch(hideSelectIconModal()),
  editMenuItem: values => dispatch(editMenuItem(values)),
  hideDeleteFeatureModal: () => dispatch(hideDeleteFeatureModal()),
  deleteMenuItem: values => dispatch(deleteMenuItem(values)),
  setIsOutdated: value => dispatch(setIsOutdated(value)),
  setSelectedFeature: value => dispatch(setSelectedFeature(value)),
  getFeatureDeepLinkUrl: values => dispatch(getFeatureDeepLinkUrl(values)),
  getFeatureDeeplinkCodes: values => dispatch(getFeatureDeeplinkCodes(values)),
  updateEventMenuFeaturesOrder: (params, eventId) =>
    dispatch(updateEventMenuFeaturesOrder(params, eventId)),
  updateLandingFeatureOrder: values =>
    dispatch(updateLandingFeatureOrder(values)),
  hideFeatureNotificationModal: () => dispatch(hideFeatureNotificationModal()),
})

MenuFeature.propTypes = {
  featureDropdownList: PropTypes.array,
  menuList: PropTypes.array,
  updateMenuList: PropTypes.func,
  onDragEnd: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuFeature)
